var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1633 0.210327C18.839 0.210327 24.2503 5.62171 24.2503 12.2974C24.2503 18.9731 18.839 24.3845 12.1633 24.3845C5.48756 24.3845 0.0761719 18.9731 0.0761719 12.2974C0.0761719 5.62171 5.48756 0.210327 12.1633 0.210327ZM12.1633 5.04516C11.8427 5.04516 11.5352 5.17251 11.3086 5.39918C11.0819 5.62586 10.9545 5.9333 10.9545 6.25387V12.2974C10.9546 12.618 11.082 12.9253 11.3087 13.152L14.9348 16.7781C15.1628 16.9983 15.4681 17.1201 15.785 17.1173C16.1019 17.1146 16.4051 16.9875 16.6292 16.7634C16.8533 16.5393 16.9804 16.2361 16.9832 15.9192C16.9859 15.6023 16.8641 15.2969 16.6439 15.069L13.372 11.797V6.25387C13.372 5.9333 13.2446 5.62586 13.0179 5.39918C12.7913 5.17251 12.4838 5.04516 12.1633 5.04516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b77a9e1b0fcb696364ef7f27578f1ccb.svg";
export { ForwardRef as ReactComponent };